import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { catchError, EMPTY, Observable } from 'rxjs';

import { validationErrorHappened } from '../../store/actions';
import { AppState, ErrorResponse, ValidationError } from '../models';

@Injectable()
export class OrderplanningValidationErrorInterceptor implements HttpInterceptor {
  private readonly store = inject<Store<AppState>>(Store);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((errors: ErrorResponse<ValidationError[]> | HttpErrorResponse) => {
        if (req.url.includes('orderplanning')) {
          const mappedErrors = this.mapValidationErrors(errors);
          if (mappedErrors.length > 0) {
            this.store.dispatch(validationErrorHappened({ errors: mappedErrors }));

            return EMPTY;
          }
        }

        throw errors;
      }),
    );
  }

  private mapValidationErrors(errors: ErrorResponse<ValidationError[]> | HttpErrorResponse): ValidationError[] {
    if (!errors?.error) {
      return [];
    }

    if (Array.isArray(errors.error)) {
      return errors.error;
    }

    const errorResponse = errors.error as CartExceptionResponse;
    if (!Array.isArray(errorResponse.translatedValidationMessages)) {
      return [];
    }

    const messages = errorResponse.translatedValidationMessages
      .map((message, index) => {
        if (!message) {
          return null;
        }

        return {
          code: '',
          message,
          data: errorResponse.contextVariables?.[index],
        } as ValidationError;
      })
      .filter((value): value is ValidationError => value !== null);

    return messages;
  }
}

interface CartExceptionResponse {
  translatedValidationMessages?: Array<string | null>;
  contextVariables?: Array<{ [key: string]: string }>;
}
